document.addEventListener("DOMContentLoaded", function () {
  const swiperSections = document.querySelectorAll(".desktopSwiper");

  swiperSections.forEach(swiperEl => {
    const sliderId = swiperEl.getAttribute("data-slider-id");
    const slides = swiperEl.querySelectorAll(".swiper-slide");
    const indicatorWrapper = document.querySelector(`.swiper-indicators[data-indicator-id="${sliderId}"]`);

    if (!swiperEl || !indicatorWrapper || slides.length === 0) return;

    const totalSlides = slides.length;
    const slidesPerView = 3;

    let totalRects = 1;
    if (totalSlides > 3 && totalSlides <= 6) {
      totalRects = 2;
    } else if (totalSlides > 6) {
      totalRects = 3;
    }

    if (totalRects <= 1) {
      indicatorWrapper.classList.add("hidden");
    } else {
      indicatorWrapper.classList.remove("hidden");
    }

    const rects = []; // ✅ scoped to this swiper
    for (let i = 0; i < totalRects; i++) {
      const rect = document.createElement("div");
      rect.className = "w-[39px] h-[6px] bg-gray-300 cursor-pointer transition-colors duration-200 rounded";
      rect.dataset.index = i;
      indicatorWrapper.appendChild(rect);
      rects.push(rect);
    }

    // ✅ Scoped to this swiper’s rects
    function updateRects(realIndex) {
      const groupIndex = Math.floor(realIndex / slidesPerView) % totalRects;
      rects.forEach((rect, i) => {
        rect.classList.toggle("bg-black", i === groupIndex);
        rect.classList.toggle("bg-gray-300", i !== groupIndex);
      });
    }

    function bindRectEvents(swiperInstance) {
      rects.forEach((rect, groupIndex) => {
        rect.addEventListener("click", () => {
          const slideIndex = groupIndex * slidesPerView;
          swiperInstance.slideToLoop(slideIndex); // ✅ only slide — background updates via `slideChange`
        });
      });
    }

    const swiper = new Swiper(swiperEl, {
  slidesPerView: slidesPerView,
  slidesPerGroup: slidesPerView, // ✅ Slide 3 slides at once
  spaceBetween: 20,
  loop: true,
  grabCursor: true,
  on: {
    init: function () {
      bindRectEvents(this);
      updateRects(this.realIndex);
    },
    slideChange: function () {
      updateRects(this.realIndex); // ✅ updates rects on slide change
    }
  }
});

  });
});
